import { Component, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
interface ymd {
  y: number;
  m: number;
  d: number;
}
function getDaysInMonth(anyDateInMonth:Date):number {
    return new Date(anyDateInMonth.getFullYear(),
                    anyDateInMonth.getMonth()+1,
                    0).getDate();}
@Component({
  selector: 'app-ymd-picker',
  templateUrl: './ymd-picker.component.html',
  styleUrls: ['./ymd-picker.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: YmdPickerComponent,
    multi: true
  }]
})
export class YmdPickerComponent implements ControlValueAccessor {

  public selectedYear: number;
  public selectedMonth: number;
  public selectedDate: number;


  private onChange: Function = (date: string) => { };
  private onTouch: Function = () => { };
  @Input() disabled: boolean = false;

  years: number[] = [];
  months: number[] = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
  ];
  dates: number[] = [];
  @Input()
  set value(value: Date) {
    this.writeValue(value);
  }
  get value(): Date {
    if(this.selectedYear && this.selectedMonth && this.selectedDate){

      return new Date([this.selectedYear, this.selectedMonth, this.selectedDate].join('-'));
    }
    return;
  }


  constructor() {
    let years = new Array(5);
    years.fill(-1);
    let thisyear = (new Date()).getFullYear();
    years = years.map((min: number, idx: number) => {
      return min * idx + thisyear;
    });
    this.years = years;
  }

  // Allow Angular to set the value on the component
  writeValue(value: Date): void {
    // console.log('writeValue',value)
    if(this.disabled) return;
    this.onChange(value);
    if (value) {
      const stringValue: string = `${value.getFullYear()}-${value.getMonth() + 1}-${value.getDate()}`;
      const [y, m, d] = stringValue.split('-');
      this.selectedYear = Number(y);
      this.selectedMonth = Number(m);
      this.selectedDate = Number(d);
      this._updateChoices(Number(y), Number(m), Number(d));
    } else {
      this.selectedYear = null;
      this.selectedMonth = null;
      this.selectedDate = null;
    }
  }

  handleSelectionChange(part:string,value:number){
    if(part == 'year'){
      this.selectedYear = Number(value);
    }else if(part == 'month' && value && value != this.selectedMonth){
      this.selectedMonth = Number(value);
      this._updateChoices(this.selectedYear,Number(value),this.selectedDate);
    }else if(part == 'date' && value && value != this.selectedDate){
      this.selectedDate = value;
      this.value = new Date(`${this.selectedYear}-${this.selectedMonth}-${this.selectedDate}`);
    }
    // console.log('handleSelectionChange',part,value)
  }
  private _updateChoices(y: number, m: number, d: number) {
    const daysInMonth = getDaysInMonth(new Date(`${y}-${m}-${1}`));
    const dates:number[] = new Array(daysInMonth);
    dates.fill(1);

    this.dates =dates.map( (n:number,i:number)=>{
      return n + i;
    });
  }

  // Save a reference to the change function passed to us by
  // the Angular form control
  registerOnChange(fn: Function): void {
    this.onChange = fn;
  }

  // Save a reference to the touched function passed to us by
  // the Angular form control
  registerOnTouched(fn: Function): void {
    this.onTouch = fn;
  }

  // Allow the Angular form control to disable this input
  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;

  }

}
